import {inject, NgModule} from '@angular/core';
import {Router, RouterModule, Routes} from '@angular/router';
import {RedirectGuard} from './guards/redirect.guard';
import {AppComponent} from './app.component';
import {DispatchScheduleViewComponent} from '@/app/standAlone/schedule/dispatch-schedule-view.component';
import {PerformanceShellComponent} from "@/app/standAlone/performance/shell/performance-shell.component";

export const localeAuthGuard = () => {
  const router = inject(Router);
  const cookies = document.cookie.split(';');

  for (const cookie of cookies) {
    let name = cookie.split('=')[0].trim();
    let value = cookie.split('=')[1]?.trim();
    if (name === 'locale') {
      if (value === 'en_US' || value == 'en-us') {
        return true;
      } else {
        return router.parseUrl('/performance');
      }
    }
  }
  return router.parseUrl('/performance');
};

const brandChildren = [
  {
    path: 'login',
    canActivate: [RedirectGuard],
    data: { title: 'Login' },
    component: AppComponent,
  },
  {
    path: 'schedule',
    component: DispatchScheduleViewComponent,
    canActivate: [localeAuthGuard]
  },
  {
    path: 'performance/:id',
    component: PerformanceShellComponent,
  },
  {
    path: 'performance',
    component: PerformanceShellComponent,
  },
  {
    path: '',
    pathMatch: 'full' as const,
    redirectTo: 'performance'
  }
];

export const routes: Routes = [
  { path: 'enelx', children: brandChildren },
  { path: 'consumersenergy', children: brandChildren },
  { path: 'dte', children: brandChildren },
  { path: 'evergy', children: brandChildren },
  { path: 'endesa', children: brandChildren },
  { path: 'demo', children: brandChildren },
  { path: 'agora', children: brandChildren },
  {
    path: 'login',
    canActivate: [RedirectGuard],
    data: { title: 'Login' },
    component: AppComponent,
  },
  {
    path: 'schedule',
    component: DispatchScheduleViewComponent,
    canActivate: [localeAuthGuard]
  },
  {
    path: 'performance/:id',
    component: PerformanceShellComponent,
  },
  {
    path: 'performance',
    component: PerformanceShellComponent,
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'performance'
  },
  {
    path: '**',
    redirectTo: 'performance'
  }
];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule] 
})
export class AppRoutingModule { }
